var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRefreshRounded = function SvgRefreshRounded(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6503 6.34999C16.0203 4.71999 13.7103 3.77999 11.1703 4.03999C7.50027 4.40999 4.48027 7.38999 4.07027 11.06C3.52027 15.91 7.27027 20 12.0003 20C15.1903 20 17.9303 18.13 19.2103 15.44C19.5303 14.77 19.0503 14 18.3103 14C17.9403 14 17.5903 14.2 17.4303 14.53C16.3003 16.96 13.5903 18.5 10.6303 17.84C8.41026 17.35 6.62027 15.54 6.15027 13.32C5.31027 9.43999 8.26027 5.99999 12.0003 5.99999C13.6603 5.99999 15.1403 6.68999 16.2203 7.77999L14.7103 9.28999C14.0803 9.91999 14.5203 11 15.4103 11H19.0003C19.5503 11 20.0003 10.55 20.0003 9.99999V6.40999C20.0003 5.51999 18.9203 5.06999 18.2903 5.69999L17.6503 6.34999Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRefreshRounded);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "refresh-rounded.ba7ecea2ce0429a3f6935678cb2c00d0.svg";